// Moon Kitchen — a small DOM cooking minigame played for the Moon King in the
// castle. A recipe shows an ordered list of ingredients; tap them in the right
// order to plate the dish. Get the order right and the King is pleased. Fully
// self-contained; styled by ui/space.css.

import { INGREDIENT_NAMES } from '../core/ingredients.js';

const ICONS = {
  'crop:wheat': '🌾', moon_cheese: '🧀', moon_egg: '🥚', moon_milk: '🥛',
  stardust: '✨', comet_sugar: '🍬', space_bun: '🍔', nebula_lettuce: '🥬'
};
const label = (k) => k.startsWith('crop:') ? 'Wheat' : (INGREDIENT_NAMES[k] || k);

export class MoonKitchen {
  constructor({ recipe, onWin, onClose } = {}){
    // recipe: { name, icon, ingredients: {key: n} } — order of keys is the target
    this.recipe = recipe;
    this.onWin = onWin || (() => {});
    this.onClose = onClose || (() => {});
    this.sequence = [];
    for (const [k, n] of Object.entries(recipe.ingredients)) for (let i = 0; i < n; i++) this.sequence.push(k);
    this.step = 0;
  }

  mount(){
    const keys = [...new Set(this.sequence)];
    // shuffle the palette so order matters
    const palette = keys.slice().sort(() => Math.random() - 0.5);
    const el = document.createElement('div');
    el.className = 'cafe-panel space-mg';
    el.innerHTML = `
      <div class="mg-card">
        <h2>${this.recipe.icon || '🌙'} ${this.recipe.name}</h2>
        <div class="mg-sub">Add the ingredients in order for the Moon King:</div>
        <div class="mk-target" id="mkTarget">${this.sequence.map((k, i) =>
          `<span class="mk-slot" data-i="${i}">${ICONS[k] || '•'}</span>`).join('')}</div>
        <div class="mk-palette">${palette.map(k =>
          `<button class="cafe-btn mk-ing" data-key="${k}">${ICONS[k] || '•'} ${label(k)}</button>`).join('')}</div>
        <button class="cafe-btn ghost mg-quit">leave the kitchen</button>
      </div>`;
    document.body.appendChild(el);
    this.el = el;
    el.querySelectorAll('.mk-ing').forEach(b => b.onclick = () => this._pick(b.dataset.key));
    el.querySelector('.mg-quit').onclick = () => { this.unmount(); this.onClose(); };
    this._paint();
  }

  _pick(key){
    if (key === this.sequence[this.step]){
      this.step++;
      this._paint();
      if (this.step >= this.sequence.length) this._win();
    } else {
      // wrong ingredient — flash and reset the sequence
      this.step = 0;
      this._paint(true);
    }
  }

  _paint(bad){
    const slots = this.el.querySelectorAll('.mk-slot');
    slots.forEach((s, i) => {
      s.classList.toggle('done', i < this.step);
      s.classList.toggle('next', i === this.step);
    });
    if (bad){
      const t = this.el.querySelector('#mkTarget');
      t.classList.add('shake');
      setTimeout(() => t.classList.remove('shake'), 400);
    }
  }

  _win(){
    const card = this.el.querySelector('.mg-card');
    card.innerHTML = `
      <h2>👑 The Moon King is delighted!</h2>
      <div class="mg-sub">"A dish worthy of the craters. Take my navigation chip, brave toast."</div>
      <button class="cafe-btn mg-ok">receive the nav chip 💾</button>`;
    card.querySelector('.mg-ok').onclick = () => { this.unmount(); this.onWin(); };
  }

  unmount(){ if (this.el){ this.el.remove(); this.el = null; } }
}
